module.exports = __webpack_public_path__ + "static/media/news-img4.fa5fde51.PNG";